<template>
    <div class="flex-grow-1">
        <div class="d-flex align-center mb-4">
            <SvgIcon :icon="orderIcon" alt="ticket" />
            <div data-id="orderHistoryItemDetailsTitle" class="text-h4 ml-3 font-weight-bold secondary-text-color">
                {{ orderLineTitle }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { IOrderHistoryCardDetails } from '../../types';
import SvgIcon from '@/features/common/components/SvgIcon.vue';
import usedTicket from '@/assets/used_ticket.svg';
import card from '@/assets/card-green.svg';

const props = defineProps<IOrderHistoryCardDetails>();

const orderIcon = props.isTicket ? usedTicket : card;
</script>
